import React from "react";
import PropTypes from "prop-types";
import { launchModal } from "MODULES/shared/decorators";

export default function LaunchModal({
  modal: Modal,
  buttonClass,
  buttonIcon = "fa-plus",
  text,
  ...rest
}) {
  const Button = launchModal((open, close) => (
    <Modal open={open} close={close} {...rest} />
  ));

  return (
    <Button buttonClass={buttonClass} text={text} buttonIcon={buttonIcon} />
  );
}

LaunchModal.propTypes = {
  modal: PropTypes.func.isRequired,
  buttonClass: PropTypes.string.isRequired,
  buttonIcon: PropTypes.string,
  text: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/LaunchModal/LaunchModal.jsx